export class DeviceBus {
    id: number;
    family: string;
    name: string;
    cxn: number;
    quantity: number;
    disableAdd: boolean;
    disableRemove: boolean;
    listBusActive: number[];

    constructor(id: number, family: string, name: string, cxn: number, listBusActive: number[]) {
        this.id = id;
        this.family = family;
        this.name = name;
        this.cxn = cxn;
        this.quantity = 0;
        this.disableAdd = false;
        this.disableRemove = false;
        this.listBusActive = listBusActive;
    }
}


export class DevicePowerOld {
    id: number;
    family: string;
    name: string;
    cxnPower: number;
    cxnAddGreenPower: number;
    quantity: number;
    power: number;
    powerGreen: number;
    disableAdd: boolean;
    disableRemove: boolean;
    listBusActive: number[];

    constructor(id: number, family: string, name: string, cxnPower: number, cxnAddGreenPower: number, power: number, powerGreen: number, listBusActive: number[]) {
        this.id = id;
        this.family = family;
        this.name = name;
        this.cxnPower = cxnPower;
        this.cxnAddGreenPower = cxnAddGreenPower;
        this.quantity = 0;
        this.power = power;
        this.powerGreen = powerGreen;
        this.disableAdd = false;
        this.disableRemove = false;
        this.listBusActive = listBusActive;
    }
}


export class BoardPower {
    id: number;
    name: string;
    maxPower: number;
    limitGreenPower: number;
    supportGreenPower: boolean;
    power: number;
    powerGreen: number;
    cxn: number;
    maxPowerGreen: number;
    maxGateway: number;
    maxSchede: number;
    maxFotocelluleBus: number;
    maxSelettoriBus: number;
    maxInterfaccieBus: number;
    maxLampeggiantiBus: number;
    maxFotocelluleOld: number;
    maxSelettoriOld: number;
    maxLampeggiantiOld: number;

    constructor(id: number, name: string, maxPower: number, limitGreenPower: number, supportGreenPower: boolean, power: number,
        powerGreen: number, maxPowerGreen: number, cxn: number,
        maxGateway: number, maxSchede: number, maxFotocelluleBus: number, maxSelettoriBus: number, maxInterfaccieBus: number,
        maxLampeggiantiBus: number, maxFotocelluleOld: number, maxSelettoriOld: number, maxLampeggiantiOld: number) {
        this.id = id;
        this.name = name;
        this.maxPower = maxPower;
        this.limitGreenPower = limitGreenPower;
        this.supportGreenPower = supportGreenPower;
        this.power = power;
        this.powerGreen = powerGreen;
        this.maxPowerGreen = maxPowerGreen;
        this.cxn = cxn;
        this.maxGateway = maxGateway;
        this.maxSchede = maxSchede;
        this.maxFotocelluleBus = maxFotocelluleBus;
        this.maxSelettoriBus = maxSelettoriBus;
        this.maxInterfaccieBus = maxInterfaccieBus;
        this.maxLampeggiantiBus = maxLampeggiantiBus;
        this.maxFotocelluleOld = maxFotocelluleOld;
        this.maxSelettoriOld = maxSelettoriOld;
        this.maxLampeggiantiOld = maxLampeggiantiOld;
    }
}


export class AccessoryPower {
    id: number;
    family: string;
    name: string;
    power: number;
    powerGreen: number;
    quantity: number;
    disableAdd: boolean;
    disableRemove: boolean;
    listBusActive: number[];
    limitGreenPower: number;

    constructor(id: number, family: string, name: string, powerGreen: number, power: number, limitGreenPower: number, listBusActive: number[]) {
        this.id = id;
        this.family = family;
        this.name = name;
        this.power = power;
        this.powerGreen = powerGreen;
        this.quantity = 0;
        this.disableAdd = false;
        this.disableRemove = false;
        this.listBusActive = listBusActive;
        this.limitGreenPower = limitGreenPower;
    }
}